import { InputAdornment, Tooltip } from '@material-ui/core/'
import { DatePicker, DatePickerView } from '@material-ui/pickers'
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date'
import React, { ReactText } from 'react'

interface ICalendarIntervalProps {
	wrapClass?: string
	placeholder?: string
	defaultVal?: (number | null)[]
	value?: (number | null)[]
	changeHandler: (value: number[]) => void
	placeholderClass?: string
	tooltip: string
	views?: DatePickerView[]
	format: string
	dateCorrectLength: number
	activePannel?: string
	min?: ReactText
	max?: ReactText
	isDisabled: boolean
	type: 'start' | 'end'
}

const CalendarOnce: React.FC<ICalendarIntervalProps> = ({
	wrapClass = '',
	placeholder = '',
	defaultVal = [],
	value = [],
	changeHandler,
	placeholderClass = '',
	tooltip,
	views,
	format,
	dateCorrectLength,
	min,
	max,
	isDisabled,
	type,
}) => {
	const onChangeHandler = (val: MaterialUiPickersDate, index: number) => {
		if (!val) return
		const year = val.getFullYear()

		if (index === 0) {
			changeHandler([year, (value?.[1] ?? defaultVal?.[1] ?? year) as number])
		} else if (index === 1) {
			changeHandler([(value?.[0] ?? defaultVal?.[0] ?? year) as number, year])
		}
	}

	const isStart = type === 'start'

	const getFormattedDate = (num?: number | null) => {
		if (num == null) return null
		return num.toString().split('.').reverse().join('-')
	}

	// Проверка на отсутствие данных для рендера
	const shouldShowPlaceholder = (defaultVal?.length ?? 0) === 0 || (defaultVal[0] == null && defaultVal[1] == null)

	if (shouldShowPlaceholder) {
		return (
			<Tooltip title={tooltip} enterDelay={1000} enterNextDelay={2000} placement='top'>
				<div className={`placeholder ${placeholderClass}`}>{placeholder}</div>
			</Tooltip>
		)
	}

	return (
		<div className={`check-plate__calendar flex ${wrapClass}`}>
			<DatePicker
				className={isStart ? 'calendar-start' : 'calendar-end'}
				variant='inline'
				views={views}
				placeholder={isStart ? 'с' : 'по'}
				format={format}
				invalidDateMessage=''
				invalidLabel=''
				maxDateMessage=''
				minDateMessage=''
				disabled={isDisabled}
				minDate={min ? min.toString().split('.').reverse().join('-') : undefined}
				maxDate={max ? max.toString().split('.').reverse().join('-') : undefined}
				defaultValue={isStart ? getFormattedDate(defaultVal?.[0]) : getFormattedDate(defaultVal?.[1])}
				value={isStart ? getFormattedDate(value?.[0]) : getFormattedDate(value?.[1])}
				onChange={data => onChangeHandler(data, isStart ? 0 : 1)}
				InputProps={{
					startAdornment: <InputAdornment position='start'>{isStart ? 'с' : 'по'}</InputAdornment>,
				}}
			/>
		</div>
	)
}

export { CalendarOnce }
